import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';
import Item from '@knowledge/common/components/Item';
import { useTranslate } from '@tolgee/react';

export const More = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  > span {
    width: 16px;
    height: 16px;
    line-height: 16px;
    margin-left: 8px;
    text-align: center;
    border-radius: 8px;
    background: #d6e8ff;
    color: #6695ff;
  }
`;

export const SpinContainer = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function Spu({
  spu,
  ...otherProps
}: HTMLAttributes<HTMLDivElement> & {
  spu: Knowledge.SPU.Spu;
}) {
  const { skus } = spu;

  const { t } = useTranslate();

  const extraContent = skus.length
    ? `${t('knowledge.已选SKU')}：${skus.map(({ skuName }) => `[${skuName}]`).join(' ')}`
    : '';

  return (
    <Item
      {...otherProps}
      item={spu}
      width={42}
      extra={extraContent ? <SpuExtra title={extraContent}>{extraContent}</SpuExtra> : null}
    />
  );
}

const SpuExtra = styled.div`
  display: inline-block;
  max-width: 100%;
  padding: 0 4px;
  color: var(--ant-primary-color);
  border: solid 1px var(--ant-primary-3);
  border-radius: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SpuList = styled.ul`
  width: 350px;
  margin: -12px -16px;
  padding: 6px;
  list-style: none;
  max-height: 210px;
  overflow: auto;
  > li {
    padding: 8px;
    border: solid 1px #d3d7e0;
    border-radius: 2px;
    & + li {
      margin-top: 8px;
    }
  }
`;

export const SingleSpu = styled.div`
  flex: 0 0 auto;
  > div {
    padding: 10px 12px;
    & + div {
      padding: 4px 12px;
      border-top: solid 1px #f0f2f5;
    }
  }
`;
